import React, { useState } from "react"
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Stack,
  Alert,
} from "@mui/material"
import Controls from "./controls/Controls"

const useConfirmationDialog = () => {
  const [open, setOpen] = useState(false)
  const [resolvePromise, setResolvePromise] = useState(null)
  const [options, setOptions] = useState({
    title: "Are you sure?",
    description: "",
    yesText: "Yes",
    yesColor: "primary",
    noText: "No",
  })

  const confirm = (newOptions) => {
    return new Promise((resolve) => {
      setOptions({ ...options, ...newOptions })
      setResolvePromise(() => resolve)
      setOpen(true)
    })
  }

  const handleCancel = () => {
    setOpen(false)
    if (resolvePromise) resolvePromise(false) // Resolve promise as false
  }

  const handleConfirm = () => {
    setOpen(false)
    if (resolvePromise) resolvePromise(true) // Resolve promise as true
  }

  const ConfirmationDialog = () => (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogTitle id="confirmation-dialog-title">{options.title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <DialogContentText id="confirmation-dialog-description">
            {options.description}
          </DialogContentText>
          {options.subTitle && (
            <Alert severity={options.subTitleSeverity}>
              {options.subTitle}
            </Alert>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Controls.Button
          onClick={handleCancel}
          variant="outlined"
          text={options.noText}
        />
        <Controls.Button
          onClick={handleConfirm}
          variant="contained"
          color={options.yesColor}
          text={options.yesText}
        />
      </DialogActions>
    </Dialog>
  )

  return { confirm, ConfirmationDialog, setConfirmOpen: setOpen }
}

export default useConfirmationDialog
